import React from 'react';

import DeleteConfirmationModal from '@/__core/components/DeleteConfirmationModal';

interface ItemDeleteModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
}

export default function ItemDeleteModal({ open, onClose, onConfirm, isLoading = false }: ItemDeleteModalProps) {
  return (
    <DeleteConfirmationModal
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      title='Xác nhận xóa vật tư'
      itemCount={1}
      itemName='vật tư'
      isLoading={isLoading}
      loadingText='Đang xóa vật tư...'
      confirmText='Xóa vật tư'
      cancelText='Hủy'
    />
  );
}
